var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-copyright"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.yearRange)+" www.yesassess.com")]),_c('p',[_vm._v("國際職業技能委員會版權所有 野原之森信息科技提供大陆区域技术支持")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"target":"_blank","href":"http://beian.miit.gov.cn"}},[_vm._v("苏ICP备 19037999号-1")])])
}]

export { render, staticRenderFns }